import {cr} from 'fire-wind-water';
import {Field} from './field';

class List extends Field {
  constructor(field) {
    super(field);
    const attr = [
      'listOptionType',
      'listDictId',
      'listLimitType',
      'listOptions',
      'options',
      'selectOptionLimit'
    ];
    cr.each(attr, d => {
      this[d] = field[d];
    });
    this.label = [];
    this.value = [];
    this.model = [];
    this.otherValue = [];
    this.selectOptionLimit = parseInt(this.selectOptionLimit, 10) || 0;
    this.listOriginal = [];
    this.setCustomError({
      key: 'otherValue', message: '',
      validator: (my) => {
        let isVaild = true;
        cr.each(my.listOptions, d => {
          if (d.checked && d.otherisFillIn == 1 && d.otherIsRequire == 1 && !d.otherValue) {
            isVaild = false;
          }
        });
        return isVaild;
      }
    });
    this.initializeListOptions();
    this.displaySelectType = 'RADIO';
    this.isError();
  }

  setValue(val) {
    this.value = val ? [val.optionValue] : [];
    this.label = val ? [val.optionId] : [];
    this.model = val || [];
    this.otherValue = [];
    if (val && val.otherisFillIn == 1) {
      this.otherValue.push({[val.optionValue]: val.otherValue});
    }
    cr.each(this.listOptions, d => {
      d.checked = this.value.indexOf(d.optionValue) !== -1;
    });
    this.dirty = true;
    this.isError();
  }

  initValue(o) {
    this.value = o.value || [];
    this.otherValue = o.otherValue || [];
    this.model = [];
    this.label = [];
    this.dirty = false;
    this.isError();
    this.initModel();
  }

  clearValue() {
    this.value = [];
    this.otherValue = [];
    this.model = [];
    this.label = [];
    this.dirty = false;
    this.listOptions.map(d => {
      d.checked = false;
      if (d.otherisFillIn == 1) {
        d.otherValue = null;
      }
      if (d.isDefault === 1) {
        this.setValue(d);
      }
    });
    this.isError();
  }

  setOtherValue(id, val) {
    const item = this.listOptions.filter(d => {
      return d.optionId == id;
    })[0] || {};
    item.otherValue = val;
    item.dirty = true;
    if (item.checked) {
      this.otherValue = [{[item.optionValue]: item.otherValue}];
    }
    this.isError();
  }

  setListOptions(list) {
    this.listOptions = list || [];
    this.initDefault();
    this.initModel();
  }

  initDefault() {
    cr.each(this.listOptions, d => {
      if (d.isDefault === 1) {
        this.setValue(d);
      }
    });
    this.dirty = false;
  }

  initModel() {
    if (this.value.length > 0 && this.model.length === 0) {
      cr.each(this.listOptions, d => {
        if (this.value.indexOf(d.optionValue) !== -1) {
          d.checked = true;
          d.otherValue = this.otherValue.filter(v => {
            return v[d.optionValue];
          })[0] || '';
          if (d.otherValue) {
            d.otherValue = d.otherValue[d.optionValue];
          }
          this.model.push(d);
          this.label.push(d.optionId);
        }
      });
    }
  }

  initializeListOptions() {
    if (this.listOptionType === 'DICT') {
      this.initDictInfo(this.fieldInfo.dictInfo);
      if (this.displayType == 4) {
        this.listOptions = this.listOriginal;
        this.isCascade = this.listOriginal.length > 1 ? 1 : 0;
        if (this.isCascade === 1) {
          this.setManyOptions();
        } else {
          this.setListOptions(this.listOriginal[0]);
        }
      } else {
        this.setListOptions(this.listOriginal[0]);
      }
    } else {
      this.initCustomList(this.fieldInfo.listOptions);
      this.setListOptions(this.listOriginal);
    }
  }

  setManyOptions() {
  }

  initDictInfo(list) {
    const arr = [];
    let i = 0;
    let child = list;
    while (child && child.length > 0) {
      if (!arr[i]) {
        arr[i] = [];
      }
      const crr = [];
      cr.each(child, d => {
        arr[i].push({
          optionId: d.paramId,
          optionValue: d.name,
          parentId: d.parentId || 0,
          otherIsRequire: 0,
          otherisFillIn: 0,
          dirty: false,
          checked: false,
          otherValue: '',
          disabled: false,
          index: i
        });
        cr.each(d.child, c => {
          cr.each(c, m => {
            m.parentId = d.paramId;
            crr.push(m);
          });
        });
      });
      child = crr.length > 0 ? crr : null;
      i++;
    }
    this.listOriginal = arr;
  }

  initCustomList(list) {
    this.listOriginal = [];
    cr.each(list, d => {
      this.listOriginal.push({
        optionId: d.optionId,
        optionValue: d.optionValue,
        otherIsRequire: parseInt(d.otherIsRequire, 10) || 0,
        otherisFillIn: parseInt(d.otherisFillIn, 10) || 0,
        dirty: false,
        checked: false,
        otherValue: '',
        disabled: false,
        isDefault: parseInt(d.isDefault, 10) || 0
      });
    });
  }

  isError() {
    this.setError();
    if (this.required === 1 && this.value.length === 0) {
      this.error.required = true;
    }
    this.hasError();
  }

}

export {List};